export var PortDataDirection;
(function (PortDataDirection) {
    /** Input */
    PortDataDirection[PortDataDirection["Input"] = 0] = "Input";
    /** Output */
    PortDataDirection[PortDataDirection["Output"] = 1] = "Output";
})(PortDataDirection || (PortDataDirection = {}));
export var PortDirectValueTypes;
(function (PortDirectValueTypes) {
    PortDirectValueTypes[PortDirectValueTypes["Float"] = 0] = "Float";
    PortDirectValueTypes[PortDirectValueTypes["Int"] = 1] = "Int";
    PortDirectValueTypes[PortDirectValueTypes["String"] = 2] = "String";
})(PortDirectValueTypes || (PortDirectValueTypes = {}));
//# sourceMappingURL=portData.js.map